import { lovemoReviews } from '@/mocks/lovemoContent';
import LovemoSectionHeading from '@/components/feature/LovemoSectionHeading';

export default function LovemoReviews() {
  return (
    <section id="lovemo-reviews" className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
        <LovemoSectionHeading
          eyebrow="用户评价"
          title="他们把心里话交给了Lovemo"
          desc="来自真实用户的陪伴瞬间，或许你也能从中找到自己的影子。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {lovemoReviews.map((review) => (
            <article
              key={review.id}
              className="lovemo-reveal flex flex-col rounded-lg border border-background-200/70 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-secondary-200"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: review.rating }).map((_, index) => (
                  <i key={index} className="ri-star-fill text-sm" aria-hidden="true" />
                ))}
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-800">
                <i className="ri-double-quotes-l mr-1 text-lg text-primary-300" aria-hidden="true" />
                {review.content}
              </p>
              <div className="mt-6 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="h-10 w-10 overflow-hidden rounded-full">
                  <img
                    src={review.avatar}
                    alt={`${review.name}的头像`}
                    className="h-10 w-10 object-cover"
                    width={40}
                    height={40}
                  />
                </span>
                <div>
                  <p className="font-label text-sm font-bold text-foreground-950">{review.name}</p>
                  <p className="text-xs text-foreground-600">{review.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}